/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const PORNCEPTUAL: CommunityData = {
  code: "pornceptual",
  inviteCode: "pornceptual",
  name: "Pornceptual",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/por-030`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmmkties600009k0qwtdqlken.jpg?uploadTime=1774515895482&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/pornceptual/web-alternative-logo.png",
        styles: "w-[200px] h-[48px] invert",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#b2b2b2",
      asideBg: "#000000",
      asideStyles: "border-r border-[#333333]",
      contentBg: "#b2b2b2",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/pornceptual/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/pornceptual/web-background-mobile.jpg",
      nonMemberBg:
        "https://media.werz.at/community-assets/pornceptual/web-background-non-member.jpg",
      mainFont: "font-['AktivGroteskCorpRegular']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !text-[#ffffff] font-['DrukWideBold'] !text-[12px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "#444444",
      item: "font-['DrukWideMedium'] text-[12px] text-[#ffffff] uppercase text-left leading-[100%] text-opacity-50 text-center border-b border-[#ffffff] !pl-0 !py-3 gap-x-[10px]",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#b2b2b2] !pb-8 border-[#000000]",
      titles:
        "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-[326px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['DrukWideMedium'] text-[12px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['DrukWideMedium'] text-[12px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[12px] text-left leading-[120%] mt-2",
          date: "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['DrukWideMedium'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "#b2b2b2",
      hero: {
        desktop:
          "https://media.werz.at/community-assets/pornceptual/web-coming-soon-hero.mp4?type=video",
        mobile:
          "https://media.werz.at/community-assets/pornceptual/web-coming-soon-hero.mp4?type=video",
        style: "bg-[#000000]",
      },
      logo: {
        desktop: "https://media.werz.at/community-assets/pornceptual/web-alternative-logo.png",
        mobile: "https://media.werz.at/community-assets/pornceptual/web-alternative-logo.png",
        style: "w-[160px] h-[38px] sm:w-[200px] sm:h-[48px]",
      },
      werzLogoColor: "#191818",
      title: "font-['DrukWideMedium'] text-[28px] leading-[120%] text-[#000000] uppercase",
      text: "font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['DrukWideBold'] text-[12px] leading-[100%] uppercase p-4 bg-[#000000] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['AktivGroteskCorpRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#000000]",
        border: "#000000",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['AktivGroteskCorpRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['AktivGroteskCorpRegular'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton:
        "font-['AktivGroteskCorpRegular'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      modal: {
        container: "bg-[#e0e0e0] px-[40px] py-[48px]",
        title:
          "font-['DrukWideMedium'] text-[24px] leading-[120%] text-[#000000] text-center uppercase",
        text: "font-['AktivGroteskCorpRegular'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-white font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#000000",
        otpBorderFocus: "#000000",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/pornceptual/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/pornceptual/web-background-non-member.jpg",
      bgColor: "#b2b2b2",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#b2b2b2]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#ffffff] font-['DrukWideMedium'] text-[20px] uppercase leading-[24px] text-center text-center mt-4 mb-1",
        location:
          "font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#b2b2b2] border border-[#000000] text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#b2b2b2] border border-[#000000]",
          title:
            "font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#b2b2b2] border border-[#000000]",
          duration:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#000000] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#b2b2b2] border border-[#000000]",
          name: "text-[#000000] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#444444] text-[#ffffff] font-['DrukWideMedium'] text-[12px] uppercase leading-[14.4px] text-center",
          duration:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['DrukWideMedium'] uppercase leading-[14.4px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['DrukWideMedium'] uppercase leading-[14.4px] text-[14px] text-left",
            link: "text-[#505050] font-['AktivGroteskCorpRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#000000] font-['DrukWideMedium'] uppercase leading-[120%] text-[14px] text-left",
            button:
              "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#b2b2b2] border border-[#000000] text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#b2b2b2] border border-[#000000]",
          name: "text-[#000000] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#b2b2b2] border border-[#000000] text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#b2b2b2] border border-[#000000]",
          coverUrl: "overflow-hidden m-2 border border-[#000000]",
          duration:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#FFF",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#FFF",
          start:
            "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#000000] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#b2b2b2] border border-[#000000] text-[#000000] font-['AktivGroteskCorpRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#b2b2b2] border border-[#000000]",
          name: "text-[#000000] font-['DrukWideMedium'] uppercase leading-[16.8px] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#505050] font-['AktivGroteskCorpRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#b2b2b2] !pb-8 border-[#444444]",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%]",
        subtitle:
          "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%] mb-4",
        button:
          "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['DrukWideBold'] !text-[12px] uppercase text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#000000] font-['DrukWideMedium'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#000000] font-['DrukWideMedium'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['DrukWideMedium'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['DrukWideMedium'] text-[20px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#b2b2b2] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#ffffff00] border-b border-[#444444] py-4",
          media: "!hidden",
          name: "text-[#000000] font-['DrukWideMedium'] text-[12px] uppercase text-left leading-[120%]",
          description:
            "text-[#8d8d8d] font-['AktivGroteskCorpRegular'] text-[14px] text-left leading-[120%] flex flex-row gap-1",
          price:
            "text-[#8d8d8d] font-['DrukWideMedium'] text-[12px] uppercase text-left leading-[120%]",
          quantity:
            "text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%]",
          status:
            "text-[#8d8d8d] font-['DrukWideMedium'] text-[12px] uppercase text-left leading-[120%]",
          counterContainer: "bg-[#b2b2b2] border border-[#000000] px-4 py-4 gap-x-4 !w-fit !h-10",
          plusMinusColor: "#000000",
          button:
            "bg-[#b2b2b2] border border-[#000000] px-4 py-4 text-[#000000] font-['DrukWideBold'] text-[12px] uppercase text-left leading-[100%] !w-fit",
        },
      },
    },
  },
}

export default PORNCEPTUAL
